import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const pipeDeteriorationApi = axiosWithHeaders({
	config,
	service: 'saasPipeDeterioration',
	axiosCreateOpts: { timeout: 15000 },
});

export default pipeDeteriorationApi;
